module.exports = __webpack_public_path__ + "img/Educate.2c9c1adb.svg";